jQuery( function ( $ ) {

  $( '.post-slider' ).each( function () {
    const $slider = $( '.slider', this );
    $slider.slick({
      rows: 0,
      infinite: false,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
          },
        },
      ],
    });
  });

});